import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import ProjectsContext from './ProjectsContext';

const Container = styled.div`
    display:flex;
    align-items:center;
    justify-content:space-between;
    width:100%;
`;

const Title = styled.div`
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
`;

const ProjectsListHeader = props => 
<ProjectsContext.Consumer>
 {context => { 
    return <Container>
        <Title>Projects</Title>
        {(context.aboutCurrentUser.isAdmin || context.aboutCurrentUser.isGbuAdmin || context.aboutCurrentUser.isOM) &&
            <Button color="primary"
            variant="contained" 
            onClick={() => context.displayAddProjectDialog()}>+ New</Button>
        }
    </Container>}
 }
</ProjectsContext.Consumer>



export default ProjectsListHeader;